export default {
  // Configuration
  BASE_URL: '',
  ENV: window.ENV,
  BUGSNAG_API_KEY: window.BUGSNAG_API_KEY,
  BUGSNAG_RELEASE_STAGE: window.BUGSNAG_RELEASE_STAGE,
  // API
  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_PRODUCT: 'GET_PRODUCT',
  GET_PRODUCT_BY_HASH: 'GET_PRODUCT_BY_HASH',
  GET_PRESETS: 'GET_PRESETS',
  GET_CUSTOM_PRODUCT: 'GET_CUSTOM_PRODUCT',
  CREATE_CUSTOM_PRODUCT: 'CREATE_CUSTOM_PRODUCT',
  UPDATE_CUSTOM_PRODUCT: 'UPDATE_CUSTOM_PRODUCT',
  UPDATE_CUSTOM_PRODUCT_FIT: 'UPDATE_CUSTOM_PRODUCT_FIT',
  BOOK_APPOINTMENT: 'BOOK_APPOINTMENT',
  GET_STORES: 'GET_STORES',

  // App
  APP_SHOW_LOADING_SCREEN_OVERLAY: 'APP_SHOW_LOADING_SCREEN_OVERLAY',
  APP_HIDE_LOADING_SCREEN_OVERLAY: 'APP_HIDE_LOADING_SCREEN_OVERLAY',
  OPEN_DROPDOWN: 'OPEN_DROPDOWN',
  CLOSE_DROPDOWN: 'CLOSE_DROPDOWN',
  APP_INIT_CUSTOM_PRODUCT: 'APP_INIT_CUSTOM_PRODUCT',
  APP_UPDATE_CUSTOM_PRODUCT: 'APP_UPDATE_CUSTOM_PRODUCT',
  APP_SET_PRODUCT_CATEGORY: 'APP_SET_PRODUCT_CATEGORY',
  APP_LOAD_PRODUCT_IN_VIEWER: 'APP_LOAD_PRODUCT_IN_VIEWER',
  APP_SET_VIEWER_REFERENCE: 'APP_SET_VIEWER_REFERENCE',
  APP_VIEWER_DID_LOAD: 'APP_VIEWER_DID_LOAD',
  APP_CHANGE_LANGUAGE: 'APP_CHANGE_LANGUAGE',
  APP_SET_PERSONAL_INFO: 'APP_SET_PERSONAL_INFO',
  APP_SET_ONLINE_PURCHASE: 'APP_SET_ONLINE_PURCHASE',

  GET_COUNTRIES: 'GET_COUNTRIES',
  COUNTRIES_CHANGED: 'COUNTRIES_CHANGED',
  UPDATE_COUNTRY: 'UPDATE_COUNTRY',
};



// WEBPACK FOOTER //
// ./src/flux/Constants.js